var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "header",
    _vm._b({ staticClass: "page-header" }, "header", _vm.$attrs, false),
    [
      _c("div", { staticClass: "d-inline-flex" }, [
        _c("h2", [_vm._v(_vm._s(_vm.pageTitle))]),
        _vm._v(" "),
        _c("hr", { staticClass: "vertical-bar" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "page-header-body" }, [_vm._t("default")], 2)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }